import { InboxOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import axios from 'axios';
import * as FileSaver from 'file-saver';
import React from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import Select from 'react-select';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { API_UPLOAD_PERSONALIZADAS, REQUEST_URL } from '../config/urls';
import MapaServices from '../services/mapa';

const getItemStyle = (isDragging, draggableStyle) => ({ ...draggableStyle }),
  getListStyle = (isDraggingOver, droppableStyle) => ({
    background: isDraggingOver ? 'aliceblue' : '',
    display: 'flex',
    overflowX: 'auto',
    maxWidth: '100vw !important',
    ...droppableStyle,
  }),
  stepper = {
    display: 'flex',
    justifyContent: 'center',
    padding: '15px 0px',
    marginTop: 25,
  },
  itemMain = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0px 20px',
  },
  itemOrder = {
    color: '#575757',
    backgroundColor: 'rgba(0,0,0,0)',
    boxShadow: '0px 1px 4px rgba(0,0,0,.2)',
    fontSize: 20,
    textAlign: 'center',
    borderRadius: 25,
    padding: 7,
    fontWeight: 'bolder',
    maxWidth: 45,
    width: 45,
    cursor: 'pointer',
  },
  itemOrderActive = {
    color: '#575757',
    backgroundColor: 'white',
    boxShadow: '0px 1px 4px rgba(0,0,0,.2)',
    fontSize: 20,
    textAlign: 'center',
    borderRadius: 25,
    padding: 7,
    fontWeight: 'bolder',
    maxWidth: 45,
    width: 45,
    cursor: 'pointer',
  },
  itemOrderDone = {
    color: 'white',
    backgroundColor: '#28a745',
    boxShadow: '0px 1px 4px rgba(0,0,0,.2)',
    fontSize: 20,
    textAlign: 'center',
    borderRadius: 25,
    padding: 7,
    fontWeight: 'bolder',
    maxWidth: 45,
    width: 45,
    cursor: 'pointer',
  },
  itemSeparator = { width: 75, height: 2, backgroundColor: 'gray' },
  estiloSelect = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? '#3c8dbc' : '#d2d6de',
      borderRadius: 0,
      '&:hover': { borderColor: state.isFocused ? '#d2d6de' : '#d2d6de' },
    }),
  },
  { Dragger } = Upload;

export default class UploadFotos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: ['Padrão', 'Personalizada', 'Vegetal', 'Finalizar'],
      contrato: '',
      personalizadas: '',
      vegetais: '',
      nomePasta: '',
      cursosSelect: [],
      turmasSelect: [],
      carregandoUpload: false,
      cursoSelecionado: {},
      turmaSelecionada: {},
      carregandoPaginas: false,
      renderizarPaginas: false,
      renderizarUpload: false,
      cadastrandoConvites: false,
      dados: [],
      links: [],
      activatedStep: 1,
    };
  }

  async componentDidMount() {
    await this.carregarListaDeCursos();
    await this.carregarListaDeTurmas();
  }

  async carregarListaDeCursos() {
    let mapaservice = new MapaServices();
    await mapaservice
      .consultarCursos()
      .then((response) => {
        let cursos = [];
        response.forEach((curso) => {
          cursos.push({ value: curso.nomecurso, label: curso.nomecurso });
        });
        this.setState({ cursosSelect: cursos });
      })
      .catch((erro) => {
        toast.error(
          'Erro ao carregar a lista de cursos. Atualize a tela e tente novamente!'
        );
        console.log(erro);
      });
  }

  async carregarListaDeTurmas() {
    await axios
      .get(`${REQUEST_URL}/lista-turmas`)
      .then((response) => {
        let turmas = [];
        response.data.forEach((turma) => {
          turmas.push({ value: turma.curso, label: turma.curso });
        });
        this.setState({ turmasSelect: turmas });
      })
      .catch(() => {
        toast.error(
          'Erro ao carregar a lista de turmas. Atualize a tela e tente novamente!'
        );
      });
  }

  onDragEndPadrao(result) {
    if (!result.destination) {
      return;
    }
    let dados = Object.assign([], this.state.dados),
      arrayAux = [],
      inseriuItem = false;
    dados.paginas = dados.paginas.filter((link, i) => {
      return i !== result.source.index;
    });
    dados.paginas.forEach((item, i) => {
      if (i === result.destination.index) {
        inseriuItem = true;
        arrayAux.push(result.draggableId);
      }
      arrayAux.push(item);
    });
    if (!inseriuItem) {
      arrayAux.push(result.draggableId);
    }
    dados.paginas = arrayAux;
    this.setState({ dados });
  }

  onDragEndPerso(result) {
    if (!result.destination) {
      return;
    }
    let dados = Object.assign([], this.state.dados),
      formandoQuePerdeu = Number(result.source.droppableId.split('-')[1]),
      formandoQueRecebeu = Number(result.destination.droppableId.split('-')[1]),
      arrayAux = [],
      inseriuItem = false;
    dados.formandos[formandoQuePerdeu].personalizadas = dados.formandos[
      formandoQuePerdeu
    ].personalizadas.filter((link, i) => {
      return i !== result.source.index;
    });
    dados.formandos[formandoQueRecebeu].personalizadas.forEach((item, i) => {
      if (i === result.destination.index) {
        inseriuItem = true;
        arrayAux.push(result.draggableId);
      }
      arrayAux.push(item);
    });
    if (!inseriuItem) {
      arrayAux.push(result.draggableId);
    }
    dados.formandos[formandoQueRecebeu].personalizadas = arrayAux;
    this.setState({ dados });
  }

  onDragEndVegetal(result) {
    if (!result.destination) {
      return;
    }
    let dados = Object.assign([], this.state.dados),
      formandoQuePerdeu = Number(result.source.droppableId.split('-')[1]),
      formandoQueRecebeu = Number(result.destination.droppableId.split('-')[1]),
      arrayAux = [],
      inseriuItem = false;
    dados.formandos[formandoQuePerdeu].vegetal = dados.formandos[
      formandoQuePerdeu
    ].vegetal.filter((link, i) => {
      return i !== result.source.index;
    });
    dados.formandos[formandoQueRecebeu].vegetal.forEach((item, i) => {
      if (i === result.destination.index) {
        inseriuItem = true;
        arrayAux.push(result.draggableId);
      }
      arrayAux.push(item);
    });
    if (!inseriuItem) {
      arrayAux.push(result.draggableId);
    }
    dados.formandos[formandoQueRecebeu].vegetal = arrayAux;
    this.setState({ dados });
  }

  handleSubmitPesquisa = async (e) => {
    e ? e.preventDefault() : null;
    if (
      this.state.contrato &&
      this.state.personalizadas &&
      this.state.vegetais &&
      this.state.nomePasta &&
      this.state.cursoSelecionado
    ) {
      this.setState({
        carregandoPaginas: true,
        renderizarUpload: false,
        dados: [],
        links: [],
        activatedStep: 1,
      });
      await axios
        .post(
          `${REQUEST_URL}/convite-online/get`,
          {
            contrato: Number(this.state.contrato),
            personalizadas: Number(this.state.personalizadas * 2),
            vegetais: Number(this.state.vegetais),
            nomePasta: this.state.nomePasta,
            curso: this.state.cursoSelecionado.value,
            nomeTurma: this.state.turmaSelecionada.value,
          },
          { headers: { 'X-Token': localStorage.getItem('tokenAlphaE') } }
        )
        .then((response) => {
          this.setState({
            dados: response.data.pageData.data,
            links:
              response.data.linkData.code === 200
                ? response.data.linkData.data
                : [],
            carregandoPaginas: false,
            renderizarPaginas: true,
          });
        })
        .catch(() => {
          this.setState({
            carregandoPaginas: false,
            renderizarPaginas: false,
            renderizarUpload: true,
          });
          toast.info(
            'Não encontramos as páginas deste contrato nessa pasta! Verifique as informações e tente novamente ou faça o upload!'
          );
        });
    } else {
      toast.info('Preencha todos os campos para fazer a consulta!');
    }
  };

  handleSubmitCadastrar = async (e) => {
    e.preventDefault(e);
    this.setState({ cadastrandoConvites: true });
    let dados = Object.assign({}, this.state.dados);
    dados = JSON.parse(JSON.stringify(dados));
    dados.contrato = Number(this.state.contrato);
    dados.nomePasta = this.state.nomePasta;
    await axios
      .post(`https://gateway.alphaeditora.com.br/api/convite-online`, dados, {
        headers: { 'X-Token': localStorage.getItem('tokenAlphaE') },
      })
      .then((response) => {
        toast.success('Convite on-line cadastrado com sucesso!');
        this.setState({
          cadastrandoConvites: false,
          renderizarPaginas: false,
          contrato: '',
          personalizadas: '',
          vegetais: '',
          nomePasta: '',
          cursoSelecionado: {},
        });
      })
      .catch((error) => {
        toast.error('Erro ao cadastrar o convite on-line. Tente novamente!');
        this.setState({ cadastrandoConvites: false });
      });
  };

  handleChangeCurso(cursoSelecionado) {
    this.setState({ cursoSelecionado });
  }

  handleChangeTurma(turmaSelecionada) {
    this.setState({ turmaSelecionada });
  }

  handleClickStep = (i) => {
    if (!this.state.cadastrandoConvites) {
      this.setState({ activatedStep: i });
    }
  };

  baixarLinks = () => {
    let nomeArquivo = `links-convite-online-${this.state.contrato}.xlsx`,
      fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      ws = XLSX.utils.json_to_sheet(this.state.links),
      wb = { Sheets: { data: ws }, SheetNames: ['data'] },
      excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' }),
      data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, nomeArquivo);
    toast.info(
      'O arquivo está sendo processado e o download será feito em instantes'
    );
  };

  uploadZipPaginas = async (file) => {
    this.setState({ carregandoUpload: true });
    let formData = new FormData();
    formData.append('conviteZip', file);
    delete axios.defaults.headers.common['Authorization'];
    await axios
      .post(API_UPLOAD_PERSONALIZADAS, formData)
      .then(async () => {
        toast.success('Upload feito com sucesso!');
        this.setState({ carregandoUpload: false });
        await this.handleSubmitPesquisa();
      })
      .catch((erro) => {
        toast.info('Erro ao fazer o upload do zip. Tente novamente!');
        this.setState({ carregandoUpload: false });
      });
    axios.defaults.headers.common['Authorization'] =
      localStorage.getItem('token');
  };

  _renderStepsHeader() {
    return (
      <div style={stepper}>
        {this.state.steps.map((item, i) => {
          if (i !== this.state.steps.length - 1) {
            return (
              <div
                key={i}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div
                  style={
                    (itemMain,
                    {
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      margin: '0px 20px',
                    })
                  }
                >
                  <div
                    style={
                      i + 1 === this.state.activatedStep
                        ? itemOrderActive
                        : this.state.activatedStep > i + 1
                        ? itemOrderDone
                        : itemOrder
                    }
                    onClick={() => {
                      this.handleClickStep(i + 1);
                    }}
                  >
                    {i + 1}
                  </div>
                  <div>{item}</div>
                </div>
                <div style={itemSeparator}></div>
              </div>
            );
          }
          return (
            <div key={i} style={itemMain}>
              <div
                style={
                  i + 1 === this.state.activatedStep
                    ? itemOrderActive
                    : this.state.activatedStep > i + 1
                    ? itemOrderDone
                    : itemOrder
                }
                onClick={() => {
                  this.handleClickStep(i + 1);
                }}
              >
                {i + 1}
              </div>
              <div>{item}</div>
            </div>
          );
        })}
      </div>
    );
  }

  _renderDragDropPadrao() {
    return (
      <DragDropContext onDragEnd={this.onDragEndPadrao.bind(this)}>
        {this.state.dados.paginas && this.state.dados.paginas.length > 0 ? (
          <div>
            <fieldset style={{ border: '1px solid gray', minHeight: '50px' }}>
              <legend style={{ width: 'auto', marginLeft: 10, border: 'none' }}>
                Páginas padrão
              </legend>
              <Droppable droppableId={`padrao-0`} direction='horizontal'>
                {(provided, snapshot) => (
                  <div
                    className='row'
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver, {
                      minHeight: '100px',
                      margin: 0,
                    })}
                  >
                    {this.state.dados.paginas.map((pagina, i) => {
                      return (
                        <Draggable
                          key={`padraoF${i}`}
                          draggableId={pagina}
                          index={i}
                        >
                          {(provided, snapshot) => (
                            <div
                              key={i}
                              className={`col-md-${
                                this.state.dados.paginas.length >= 6 ? 1 : 2
                              }`}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style
                              )}
                            >
                              <img
                                className='img-thumbnail'
                                key={i}
                                src={pagina}
                                alt='Página padrão'
                              />
                              <p>
                                {
                                  pagina.split('/')[
                                    pagina.split('/').length - 2
                                  ]
                                }
                                /
                                {
                                  pagina.split('/')[
                                    pagina.split('/').length - 1
                                  ]
                                }
                              </p>
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                  </div>
                )}
              </Droppable>
            </fieldset>
          </div>
        ) : (
          <div>Nenhuma página cadastrada</div>
        )}
      </DragDropContext>
    );
  }

  _renderDragDropPerso() {
    return (
      <DragDropContext onDragEnd={this.onDragEndPerso.bind(this)}>
        {this.state.dados.formandos.length > 0 ? (
          this.state.dados.formandos.map((formando, i) => (
            <div key={i}>
              <fieldset style={{ border: '1px solid gray', minHeight: '50px' }}>
                <legend
                  style={{ width: 'auto', marginLeft: 10, border: 'none' }}
                >
                  {formando.nome}
                </legend>
                <Droppable droppableId={`perso-${i}`} direction='horizontal'>
                  {(provided, snapshot) => (
                    <div
                      className='row'
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver, {
                        minHeight: '100px',
                        margin: 0,
                      })}
                    >
                      {formando.personalizadas.length > 0 ? (
                        formando.personalizadas.map((foto, j) => {
                          return (
                            <Draggable
                              key={`persoF${j}`}
                              draggableId={foto}
                              index={j}
                            >
                              {(provided, snapshot) => (
                                <div
                                  key={j}
                                  className={`col-md-${
                                    formando.personalizadas.length >= 6 ? 1 : 2
                                  }`}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style
                                  )}
                                >
                                  <img
                                    className='img-thumbnail'
                                    key={i}
                                    src={foto}
                                    alt='Personalizada'
                                  />
                                  <p>
                                    {
                                      foto.split('/')[
                                        foto.split('/').length - 2
                                      ]
                                    }
                                    /
                                    {
                                      foto.split('/')[
                                        foto.split('/').length - 1
                                      ]
                                    }
                                  </p>
                                </div>
                              )}
                            </Draggable>
                          );
                        })
                      ) : (
                        <h6 style={{ marginLeft: 10 }}>
                          Este formando não possui nenhuma personalizada
                          vinculada
                        </h6>
                      )}
                    </div>
                  )}
                </Droppable>
              </fieldset>
            </div>
          ))
        ) : (
          <div>Nenhum formando cadastrado</div>
        )}
      </DragDropContext>
    );
  }

  _renderDragDropVegetal() {
    return (
      <DragDropContext onDragEnd={this.onDragEndVegetal.bind(this)}>
        {this.state.dados.formandos.length > 0 ? (
          this.state.dados.formandos.map((formando, i) => (
            <div key={i}>
              <fieldset style={{ border: '1px solid gray', minHeight: '50px' }}>
                <legend
                  style={{ width: 'auto', marginLeft: 10, border: 'none' }}
                >
                  {formando.nome}
                </legend>
                <Droppable droppableId={`vegetal-${i}`} direction='horizontal'>
                  {(provided, snapshot) => (
                    <div
                      className='row'
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver, {
                        minHeight: '100px',
                        margin: 0,
                      })}
                    >
                      {formando.vegetal.length > 0 ? (
                        formando.vegetal.map((foto, j) => {
                          return (
                            <Draggable
                              key={`vegF${j}`}
                              draggableId={foto}
                              index={j}
                            >
                              {(provided, snapshot) => (
                                <div
                                  key={j}
                                  className={`col-md-${
                                    formando.vegetal.length >= 6 ? 1 : 2
                                  }`}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style
                                  )}
                                >
                                  <img
                                    className='img-thumbnail'
                                    key={i}
                                    src={foto}
                                    alt='Vegetal'
                                  />
                                  <p>
                                    {
                                      foto.split('/')[
                                        foto.split('/').length - 2
                                      ]
                                    }
                                    /
                                    {
                                      foto.split('/')[
                                        foto.split('/').length - 1
                                      ]
                                    }
                                  </p>
                                </div>
                              )}
                            </Draggable>
                          );
                        })
                      ) : (
                        <h6 style={{ marginLeft: 10 }}>
                          Este formando não possui nenhum vegetal vinculado
                        </h6>
                      )}
                    </div>
                  )}
                </Droppable>
              </fieldset>
            </div>
          ))
        ) : (
          <div>Nenhum formando cadastrado</div>
        )}
      </DragDropContext>
    );
  }

  _renderFinalStep() {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            backgroundColor: '#FFF',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            padding: 20,
            boxShadow: '0 1px 1px rgba(0,0,0,0.1)',
          }}
        >
          <p
            style={{
              fontSize: 18,
              marginBottom: 15,
              textAlign: 'center',
              fontWeight: 600,
            }}
          >
            Após confirmar a ordem das páginas, clique no botão abaixo <br />{' '}
            para criar o convite on-line deste contrato.
          </p>
          <button
            className='btn btn-lg btn-danger'
            disabled={this.state.cadastrandoConvites}
            onClick={this.handleSubmitCadastrar}
          >
            {this.state.cadastrandoConvites ? (
              <span>
                <i className='fa fa-spinner fa-spin' /> Cadastrando
              </span>
            ) : (
              'Cadastrar'
            )}
          </button>
        </div>
      </div>
    );
  }

  _renderUploadBox() {
    return (
      <div className='col-sm-12 col-md-4' style={{ position: 'relative' }}>
        <Dragger
          name='arquivoZip'
          beforeUpload={(file) => {
            this.uploadZipPaginas(file);
          }}
        >
          <p className='ant-upload-drag-icon'>
            <InboxOutlined />
          </p>
          <p className='ant-upload-text'>
            Clique aqui ou arraste o .zip para cá
            <br />
            para fazer o upload de arquivos!
          </p>
        </Dragger>
        {this.state.carregandoUpload ? (
          <div
            style={{
              backgroundColor: 'rgba(255,255,255,.9)',
              width: 'calc(100% - 30px)',
              height: '100%',
              position: 'absolute',
              top: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: 20,
              fontWeight: 600,
              color: 'black',
            }}
          >
            <i className='fa fa-spinner fa-spin' style={{ marginRight: 5 }} />{' '}
            Carregando
          </div>
        ) : null}
      </div>
    );
  }

  _renderDownloadLinksBox() {
    return (
      <div className='col-sm-12 col-md-3'>
        <div
          style={{
            backgroundColor: '#FAFAFA',
            border: '1px dashed #d9d9d9',
            borderRadius: 2,
            padding: 15,
          }}
        >
          <p style={{ fontSize: 16, color: 'black', marginBottom: 0 }}>
            <i className='fa fa-info-circle' /> Os convites on-line deste
            contrato já foram gerados.{' '}
            <a onClick={this.baixarLinks}>Clique aqui</a> para fazer o download
            dos links.
          </p>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.state.renderizarPaginas ? (
          <div>
            <div className='row'>
              {this._renderUploadBox()}
              {this.state.links.length > 0
                ? this._renderDownloadLinksBox()
                : null}
            </div>
            <div className='row'>
              <div className='col-sm-12 col-md-12'>
                {this._renderStepsHeader()}
                {this.state.activatedStep === 1
                  ? this._renderDragDropPadrao()
                  : this.state.activatedStep === 2
                  ? this._renderDragDropPerso()
                  : this.state.activatedStep === 3
                  ? this._renderDragDropVegetal()
                  : this.state.activatedStep === 4
                  ? this._renderFinalStep()
                  : null}
              </div>
            </div>
          </div>
        ) : (
          <div className='row'>
            <div className='col-sm-12 col-md-4'>
              <div className='box'>
                <div className='box-body'>
                  <form onSubmit={this.handleSubmitPesquisa}>
                    <div className='form-group'>
                      <label htmlFor='contrato'>Contrato</label>
                      <input
                        type='number'
                        name='contrato'
                        id='contrato'
                        value={this.state.contrato}
                        onChange={(e) => {
                          this.setState({ contrato: e.target.value });
                        }}
                        className='form-control'
                      />
                    </div>
                    <div className='form-group'>
                      <label htmlFor='nomePasta'>Pasta</label>
                      <input
                        type='text'
                        name='nomePasta'
                        id='nomePasta'
                        value={this.state.nomePasta}
                        onChange={(e) => {
                          this.setState({ nomePasta: e.target.value });
                        }}
                        className='form-control'
                      />
                    </div>
                    <div className='form-group'>
                      <label htmlFor='curso'>Curso</label>
                      <Select
                        placeholder='Selecione o curso'
                        name='curso'
                        options={this.state.cursosSelect}
                        value={this.state.cursosSelecionados}
                        onChange={this.handleChangeCurso.bind(this)}
                        styles={estiloSelect}
                        required
                      />
                    </div>
                    <div className='form-group'>
                      <label htmlFor='turma'>Turma</label>
                      <Select
                        placeholder='Selecione a turma'
                        name='nomeTurma'
                        options={this.state.turmasSelect}
                        value={this.state.turmaSelecionada}
                        onChange={this.handleChangeTurma.bind(this)}
                        required
                        styles={estiloSelect}
                      />
                    </div>
                    <div className='form-group'>
                      <label htmlFor='personalizadas'>
                        Quantidade de personalizadas por formando (folha)
                      </label>
                      <input
                        type='number'
                        className='form-control'
                        name='personalizadas'
                        id='personalizadas'
                        value={this.state.personalizadas}
                        onChange={(e) => {
                          this.setState({ personalizadas: e.target.value });
                        }}
                      />
                    </div>
                    <div className='form-group'>
                      <label htmlFor='vegetais'>
                        Quantidade de vegetal por formando (folha)
                      </label>
                      <input
                        type='number'
                        className='form-control'
                        name='vegetais'
                        id='vegetais'
                        value={this.state.vegetais}
                        onChange={(e) => {
                          this.setState({ vegetais: e.target.value });
                        }}
                      />
                    </div>
                    <div
                      style={{ display: 'flex', justifyContent: 'flex-end' }}
                    >
                      <button
                        type='submit'
                        className='btn btn-info'
                        disabled={this.state.carregandoPaginas}
                      >
                        {this.state.carregandoPaginas ? (
                          <span>
                            <i className='fa fa-spinner fa-spin' /> Pesquisando
                          </span>
                        ) : (
                          'Pesquisar'
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {this.state.renderizarUpload ? this._renderUploadBox() : null}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/UploadFotos.js